module.exports = __webpack_public_path__ + "img/icon_visitor.010d0960.png";